module.exports = __webpack_public_path__ + "img/1008_pc.5aa9b196.gif";